import React, { useState, useEffect, Suspense, lazy } from "react";
import Carousel from "react-spring-3d-carousel-2";
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";
import { StyledModal } from "../styles";
import { config } from "react-spring";
import "./videohighlights.css";
import arrowimgl from "../../../images/orange-arrow-left.png";
import arrowimgr from "../../../images/orange-arrow-right.png";

const Video = lazy(() => import("../video"));

export default function VideoHighlights() {
  let slides = [];
  const imgURL = process.env.REACT_APP_MORGANROCKS_CDN_URL;
  const [BannerPics, setBannerPics] = useState([]);
  const [play, setPlay] = useState(false);
  const [url, setUrl] = useState("");
  const videoToggle = (play, url) => {
    setPlay(!play);
    setUrl(url);
  };
  const audio = new Audio();
  audio.src = process.env.REACT_APP_CLICK_SOUND;

  const [state, setState] = useState({
    goToSlide: 0,
    offsetRadius: 3,
    showNavigation: false,
    config: config.gentle,
    draggable: true,
  });

  // const onChangeInput = (e) => {
  //   setState({
  //     [e.target.name]: parseInt(e.target.value, 10) || 0,
  //   });
  // };

  let xDown = null;
  let yDown = null;

  const getTouches = (evt) => {
    return (
      evt.touches || evt.originalEvent.touches // browser API
    ); // jQuery
  };



  const handleTouchStart = (evt) => {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
    audio.play();
  };

  const handleTouchMove = (evt) => {
    if (!xDown || !yDown) {
      return;
    }

    let xUp = evt.touches[0].clientX;
    let yUp = evt.touches[0].clientY;

    let xDiff = xDown - xUp;
    let yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /*most significant*/
      if (xDiff > 0) {
        /* left swipe */
        setState({ goToSlide: state.goToSlide + 1, offsetRadius: 3 });
      } else {
        /* right swipe */
        setState({ goToSlide: state.goToSlide - 1, offsetRadius: 3 });
      }
    } else {
      if (yDiff > 0) {
        /* up swipe */
      } else {
        /* down swipe */
      }
    }
    audio.play();
    /* reset values */
    xDown = null;
    yDown = null;
  };

  useEffect(() => {
    // Get the event pics from a JSON file hosted in the cdn
    async function fetchBannerPics() {
      try {
        const memoryPics = await axios.get(
          process.env.REACT_APP_EXP_CDN_URL
        );
        // console.log(memoryPics.data);
        let memoryPicsData = memoryPics.data;
        for (var data of memoryPicsData) {
          slides.push({
            key: data.thumbnail,
            content: (
              <a href={data.url} target="_blank">
                <img src={imgURL + data.thumbnail} className="postimages" 
                alt="Video Highlights"/>
              </a>
            ),
          });
        }
        // console.log("slides: " + JSON.stringify(slides));
        let BannerPicsData = slides.map((slide, index) => {
          return {
            ...slide,
            onClick: () => setState({ goToSlide: index, offsetRadius: 3 }),
          };
        });
        setBannerPics(BannerPicsData);
      } catch (err) {
        console.log(err);
      }
    }
    fetchBannerPics();
  }, []);

  return (
    <>
      <div>

        <Container>
          <Row>
            <Col>
              <p className="video-heading1">Video Highlights</p>
            </Col>
          </Row>
          <Col lg={8} xl={8} md={12} sm={12} className="highlightsCarousel">
            <div
              className="posts1"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
            >
              <Carousel
                slides={BannerPics}
                autoPlay
                draggable={state.draggable}
                goToSlide={state.goToSlide}
                offsetRadius={state.offsetRadius}
                showNavigation={state.showNavigation}
                animationConfig={state.config}
                goToSlideDelay="20000"
                interval={20}
              />
            </div>
            <div className="arrows">
              <img
                src={arrowimgl}
                className="leftarrow"

                alt="leftnavigation"
                onClick={() => {
                  setState({ goToSlide: state.goToSlide - 1, offsetRadius: 3 });
                  audio.play();
                }}
              />

              <img
                src={arrowimgr}
                className="rightarrow"
                alt="rightnavigation"
                id="blue-right-arrow"
                onClick={() => {
                  setState({ goToSlide: state.goToSlide + 1, offsetRadius: 3 });
                  audio.play();
                }}
              />
            </div>
          </Col>
        </Container>
      </div>
      <Suspense fallback={<div />}>
        <StyledModal show={play}>
          <Video onClose={() => videoToggle(play, '')} url={url} />
        </StyledModal>
      </Suspense>
    </>
  );

}